/* ==========================================================================
   Exin — Offertförfrågan
   Ersätter Omega RFQ-appen. Offertkorgen sparas i localStorage och skickas
   via Shopifys kontaktformulär (snippets/exin-quote-drawer.liquid).
   Knappen på produktsidan: snippets/exin-quote-button.liquid.
   ========================================================================== */
(function () {
  'use strict';

  var ITEMS_KEY = 'exin:quote:items';
  var PENDING_KEY = 'exin:quote:pending';
  var PENDING_MAX_AGE = 2 * 60 * 60 * 1000; // 2 h

  var root = document.getElementById('ExinQuote');
  if (!root) return;

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  var tab = $('[data-exq-open]');
  var countEl = $('[data-exq-count]');
  var overlay = $('[data-exq-overlay]');
  var modal = $('.exq-modal');
  var steps = $('[data-exq-steps]');
  var listEl = $('[data-exq-list]');
  var emptyEl = $('[data-exq-empty]');
  var totalRow = $('[data-exq-total-row]');
  var totalEl = $('[data-exq-total]');
  var nextBtn = $('[data-exq-next]');
  var form = document.getElementById('ExinQuoteForm');
  var errorEl = $('[data-exq-error]');
  var summaryEl = $('[data-exq-summary]');
  var receiptEl = $('[data-exq-receipt]');
  var toastEl = $('[data-exq-toast]');
  var shopUrl = (root.getAttribute('data-shop-url') || window.location.origin).replace(/\/$/, '');
  var lastFocus = null;
  var toastTimer = null;
  var lastReceipt = null; // skickad förfrågan som visas i tackrutan (underlag för PDF)

  /* ---------- lagring ---------- */
  function readJSON(key) {
    try { var s = window.localStorage.getItem(key); return s ? JSON.parse(s) : null; } catch (e) { return null; }
  }
  function writeJSON(key, val) {
    try {
      if (val == null) window.localStorage.removeItem(key);
      else window.localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {}
  }
  function getItems() {
    var items = readJSON(ITEMS_KEY);
    return Array.isArray(items) ? items : [];
  }
  function setItems(items) {
    writeJSON(ITEMS_KEY, items.length ? items : null);
    renderAll();
  }

  /* ---------- format ---------- */
  function vatIncluded() {
    return !!(window.ExinVat && window.ExinVat.isIncluded);
  }
  function money(cents, forceExVat) {
    var c = cents || 0;
    if (!forceExVat && vatIncluded()) c = Math.round(c * 1.25);
    var kr = c / 100;
    var str = kr.toLocaleString('sv-SE', {
      minimumFractionDigits: kr % 1 ? 2 : 0,
      maximumFractionDigits: 2
    });
    return str + ' kr';
  }
  function vatLabel() { return vatIncluded() ? 'inkl. moms' : 'exkl. moms'; }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function variantLabel(it) {
    return it.variantTitle && it.variantTitle !== 'Default Title' ? it.variantTitle : '';
  }
  function itemUrl(it) {
    // ?variant= bara när produkten har varianter (storlek/färg) → kortare länk annars
    return shopUrl + it.url + (it.variantId && variantLabel(it) ? '?variant=' + it.variantId : '');
  }
  function totalCents(items) {
    return items.reduce(function (sum, it) { return sum + (it.price || 0) * (it.qty || 1); }, 0);
  }
  function makeRef() {
    var d = new Date();
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    var rand = Math.random().toString(36).slice(2, 6).toUpperCase();
    return 'EX-' + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate()) + '-' + rand;
  }
  function today() {
    return new Date().toLocaleDateString('sv-SE');
  }

  /* ---------- rendering ---------- */
  function renderTab(items) {
    var n = items.reduce(function (s, it) { return s + (it.qty || 1); }, 0);
    countEl.textContent = n;
    tab.hidden = items.length === 0;
  }

  function rowHTML(it, i) {
    var vl = variantLabel(it);
    return (
      '<div class="exq-row" data-index="' + i + '">' +
        '<a class="exq-row__img" href="' + esc(it.url) + (it.variantId ? '?variant=' + it.variantId : '') + '">' +
          (it.image ? '<img src="' + esc(it.image) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="exq-row__info">' +
          '<a class="exq-row__title" href="' + esc(it.url) + (it.variantId ? '?variant=' + it.variantId : '') + '">' + esc(it.title) + '</a>' +
          (vl ? '<div class="exq-row__meta">' + esc(vl) + '</div>' : '') +
          '<div class="exq-row__meta">' + money(it.price) + ' / st' + (it.sku ? ' · Art.nr ' + esc(it.sku) : '') + '</div>' +
          '<input class="exq-row__note" type="text" data-exq-note maxlength="300" placeholder="Kommentar till produkten (valfritt)" value="' + esc(it.note || '') + '" aria-label="Kommentar till ' + esc(it.title) + '">' +
        '</div>' +
        '<div class="exq-row__side">' +
          '<div class="exq-qty">' +
            '<button type="button" data-exq-qty="-1" aria-label="Minska antal">−</button>' +
            '<input type="number" min="1" max="9999" value="' + (it.qty || 1) + '" data-exq-qty-input aria-label="Antal">' +
            '<button type="button" data-exq-qty="1" aria-label="Öka antal">+</button>' +
          '</div>' +
          '<div class="exq-row__sum">' + money((it.price || 0) * (it.qty || 1)) + '</div>' +
          '<button type="button" class="exq-row__remove" data-exq-remove>Ta bort</button>' +
        '</div>' +
      '</div>'
    );
  }

  function renderList(items) {
    listEl.innerHTML = items.map(rowHTML).join('');
    emptyEl.hidden = items.length > 0;
    totalRow.hidden = items.length === 0;
    nextBtn.disabled = items.length === 0;
    totalEl.textContent = money(totalCents(items));
    $$('[data-exq-vat-label]').forEach(function (el) { el.textContent = vatLabel(); });
  }

  function summaryHTML(items, opts) {
    opts = opts || {};
    var rows = items.map(function (it) {
      var vl = variantLabel(it);
      return (
        '<div class="exq-sum-row">' +
          (it.image ? '<img src="' + esc(it.image) + '" alt="">' : '<span class="exq-sum-row__ph"></span>') +
          '<div class="exq-sum-row__info">' +
            '<strong>' + esc(it.title) + '</strong>' +
            (vl ? '<span>' + esc(vl) + '</span>' : '') +
            (opts.sku && it.sku ? '<span>Art.nr ' + esc(it.sku) + '</span>' : '') +
            (it.note ? '<span class="exq-sum-row__note">Kommentar: ' + esc(it.note) + '</span>' : '') +
          '</div>' +
          '<div class="exq-sum-row__qty">' + (it.qty || 1) + ' st</div>' +
          '<div class="exq-sum-row__price">' + money((it.price || 0) * (it.qty || 1), opts.exVat) + '</div>' +
        '</div>'
      );
    }).join('');
    return (
      '<div class="exq-sum">' +
        (opts.heading ? '<h3 class="exq-sum__title">' + esc(opts.heading) + '</h3>' : '') +
        rows +
        '<div class="exq-sum__total"><span>Totalt</span><span><strong>' + money(totalCents(items), opts.exVat) + '</strong> ' +
          (opts.exVat ? 'exkl. moms' : vatLabel()) + '</span></div>' +
      '</div>'
    );
  }

  function renderAll() {
    var items = getItems();
    renderTab(items);
    if (!overlay.hidden) {
      var view = currentView();
      if (view === 'list') renderList(items);
      if (view === 'contact') {
        if (!items.length) { showView('list'); renderList(items); }
        else summaryEl.innerHTML = summaryHTML(items, { heading: 'Produkter i förfrågan' });
      }
    }
  }

  /* ---------- vyer ---------- */
  function currentView() {
    var v = $$('[data-exq-view]').filter(function (el) { return !el.hidden; })[0];
    return v ? v.getAttribute('data-exq-view') : null;
  }
  function showView(name) {
    $$('[data-exq-view]').forEach(function (el) { el.hidden = el.getAttribute('data-exq-view') !== name; });
    steps.hidden = name === 'done';
    $$('.exq-steps__item', steps).forEach(function (li) {
      var s = li.getAttribute('data-step');
      li.classList.toggle('is-active', (name === 'list' && s === '1') || (name === 'contact' && s === '2'));
      li.classList.toggle('is-done', name === 'contact' && s === '1');
    });
    var body = $('[data-exq-view="' + name + '"] .exq-body');
    if (body) body.scrollTop = 0;
  }

  function open(view) {
    lastFocus = document.activeElement;
    var items = getItems();
    view = view || 'list';
    if (view === 'list') renderList(items);
    if (view === 'contact') summaryEl.innerHTML = summaryHTML(items, { heading: 'Produkter i förfrågan' });
    showView(view);
    overlay.hidden = false;
    document.documentElement.classList.add('exq-lock');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); modal.focus(); });
  }
  function close() {
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.documentElement.classList.remove('exq-lock');
    if (currentView() === 'done') {
      receiptEl.innerHTML = '';
      showView('list');
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function toast(html) {
    toastEl.innerHTML = html;
    toastEl.hidden = false;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
      setTimeout(function () { toastEl.hidden = true; }, 250);
    }, 4000);
  }

  /* ---------- lägg till från produktsida ---------- */
  function addFromButton(btn) {
    var pid = btn.getAttribute('data-product-id');
    var dataEl = document.querySelector('script[data-exq-product="' + pid + '"]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    // Vald variant + antal från produktformuläret på samma sida
    var scope = btn.closest('.product-info, product-info, .main-product, section') || document;
    var idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]') ||
      document.querySelector('form[action*="/cart/add"] [name="id"]');
    var variantId = idInput && idInput.value ? parseInt(idInput.value, 10) : data.selected;
    var qtyInput = scope.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;

    var v = data.variants.filter(function (x) { return x.id === variantId; })[0] || data.variants[0];
    if (!v) return;

    var items = getItems();
    var existing = items.filter(function (it) { return it.variantId === v.id; })[0];
    if (existing) {
      existing.qty = (existing.qty || 1) + qty;
    } else {
      items.push({
        variantId: v.id,
        productId: data.id,
        title: data.title,
        variantTitle: v.title,
        sku: v.sku || '',
        price: v.price,
        image: v.image || '',
        url: data.url,
        qty: qty,
        note: ''
      });
    }
    setItems(items);
    open('list');
  }

  /* ---------- steg 2: validering + skicka ---------- */
  function fieldValue(name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }
  function validate() {
    var bad = [];
    var name = form.querySelector('[name="contact[Namn]"]');
    var email = form.querySelector('[name="contact[email]"]');
    var phone = form.querySelector('[name="contact[Telefon]"]');
    [name, email, phone].forEach(function (el) { el.classList.remove('is-invalid'); });
    if (!name.value.trim()) bad.push(name);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) bad.push(email);
    if (phone.value.replace(/[^\d]/g, '').length < 6) bad.push(phone);
    bad.forEach(function (el) { el.classList.add('is-invalid'); });
    if (bad.length) {
      errorEl.textContent = 'Fyll i namn, en giltig e-postadress och telefonnummer.';
      errorEl.hidden = false;
      bad[0].focus();
      return false;
    }
    errorEl.hidden = true;
    return true;
  }

  /* PDF-länk: hela förfrågan packad i länkens #-del (skickas aldrig till servern).
     Kompakta nycklar för kortare länk. */
  function b64urlEncode(str) {
    var bytes = new TextEncoder().encode(str), bin = '';
    for (var i = 0; i < bytes.length; i++) bin += String.fromCharCode(bytes[i]);
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function b64urlDecode(s) {
    s = s.replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    var bin = atob(s), bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    return new TextDecoder().decode(bytes);
  }
  function packReceipt(p) {
    var c = p.contact || {};
    return b64urlEncode(JSON.stringify({
      r: p.ref, d: p.date, w: p.wishes || '',
      c: [c.name || '', c.company || '', c.email || '', c.phone || ''],
      i: (p.items || []).map(function (it) {
        return [it.title, it.variantTitle || '', it.sku || '', it.price || 0, it.qty || 1, it.note || '',
          (it.image || '').replace(/^https?:/, ''), it.url || '', it.variantId || 0];
      })
    }));
  }
  function unpackReceipt(s) {
    var o = JSON.parse(b64urlDecode(s));
    var c = o.c || [];
    return {
      ref: o.r, date: o.d, wishes: o.w,
      contact: { name: c[0], company: c[1], email: c[2], phone: c[3] },
      items: (o.i || []).map(function (a) {
        return { title: a[0], variantTitle: a[1], sku: a[2], price: a[3], qty: a[4], note: a[5],
          image: a[6], url: a[7], variantId: a[8] };
      }),
      fromLink: true
    };
  }

  // Ett dolt fält per uppgift → varsin rubrik i Shopifys mejl, i denna ordning
  function fillHiddenFields(p) {
    var box = $('[data-exq-hidden-fields]');
    box.innerHTML = '';
    // "Offertförfrågan: <referens>" först i formuläret → hamnar överst i mejlet (Shopify listar fälten
    // i formulärets ordning), så att offertförfrågningar syns direkt bland vanliga kontaktmeddelanden
    var prevArende = form.querySelector('[data-exq-arende]');
    if (prevArende) prevArende.parentNode.removeChild(prevArende);
    var arende = document.createElement('input');
    arende.type = 'hidden';
    arende.name = 'contact[Offertförfrågan]';
    arende.value = p.ref;
    arende.setAttribute('data-exq-arende', '');
    form.insertBefore(arende, form.firstChild);
    var add = function (key, val) {
      var el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'contact[' + key + ']';
      el.value = val;
      box.appendChild(el);
    };
    (p.items || []).forEach(function (it, i) {
      var vl = variantLabel(it);
      var parts = [
        it.title + (vl ? ' (' + vl + ')' : ''),
        (it.qty || 1) + ' st × ' + money(it.price, true) + ' = ' + money((it.price || 0) * (it.qty || 1), true)
      ];
      if (it.sku) parts.push('Art.nr ' + it.sku);
      if (it.note) parts.push('Kommentar: ' + it.note);
      if (it.url) parts.push(itemUrl(it)); // klickbar länk till produkten i mejlet
      add('Produkt ' + (i + 1), parts.join('  ·  '));
    });
    add('Totalt', money(totalCents(p.items || []), true) + ' exkl. moms');
    add('Önskemål', p.wishes || '–');
    add('Öppna som PDF', shopUrl + '/#exq=' + packReceipt(p));
    // Samma uppgifter, men öppnas ifyllda i offertverktyget (sidan "Internt", kräver inloggning)
    add('Öppna i offertverktyget', shopUrl + '/pages/internt#exqt=' + packReceipt(p));
  }

  function submit(e) {
    e.preventDefault();
    var items = getItems();
    if (!items.length) { showView('list'); renderList(items); return; }
    if (!validate()) return;

    var pending = {
      ts: Date.now(),
      ref: makeRef(),
      date: today(),
      items: items,
      contact: {
        name: fieldValue('contact[Namn]'),
        company: fieldValue('contact[Företag]'),
        email: fieldValue('contact[email]'),
        phone: fieldValue('contact[Telefon]')
      },
      wishes: ($('[data-exq-wishes]').value || '').trim()
    };
    fillHiddenFields(pending);
    writeJSON(PENDING_KEY, pending);

    var submitBtn = $('[data-exq-submit]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Skickar…';
    form.submit();
  }

  /* ---------- tackruta / kvitto ---------- */
  function receiptHTML(p) {
    var logoTpl = $('[data-exq-logo]');
    var logo = logoTpl ? logoTpl.innerHTML : '';
    var c = p.contact || {};
    return (
      '<div class="exq-rc">' +
        '<div class="exq-rc__print-head">' + logo + '</div>' +
        '<div class="exq-rc__check" aria-hidden="true"><svg viewBox="0 0 24 24" width="28" height="28"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
        (p.fromLink
          ? '<h3 class="exq-rc__title">Offertförfrågan ' + esc(p.ref) + '</h3>' +
            '<p class="exq-rc__lead">Skickad via webbshoppen ' + esc(p.date) + '.</p>'
          : '<h3 class="exq-rc__title">Tack för din offertförfrågan!</h3>' +
            '<p class="exq-rc__lead">Vi har tagit emot din förfrågan och återkommer så snart vi kan med en offert. ' +
              'Har du frågor under tiden når du oss på <a href="tel:021171730">021-17 17 30</a> eller <a href="mailto:info@exin.se">info@exin.se</a>.</p>') +
        '<dl class="exq-rc__meta">' +
          '<div><dt>Referens</dt><dd>' + esc(p.ref) + '</dd></div>' +
          '<div><dt>Datum</dt><dd>' + esc(p.date) + '</dd></div>' +
          '<div><dt>Namn</dt><dd>' + esc(c.name) + '</dd></div>' +
          (c.company ? '<div><dt>Företag</dt><dd>' + esc(c.company) + '</dd></div>' : '') +
          '<div><dt>E-post</dt><dd>' + esc(c.email) + '</dd></div>' +
          '<div><dt>Telefon</dt><dd>' + esc(c.phone) + '</dd></div>' +
        '</dl>' +
        summaryHTML(p.items || [], { heading: 'Produkter i förfrågan', exVat: true, sku: true }) +
        (p.wishes ? '<div class="exq-rc__wishes"><strong>Önskemål</strong><p>' + esc(p.wishes).replace(/\n/g, '<br>') + '</p></div>' : '') +
        '<p class="exq-rc__foot">Priserna är ordinarie webbshoppriser exkl. moms och utgör ingen offert. ' +
          'Exin Bygg &amp; Inredning i Västerås AB · Metallverksgatan 21, 721 30 Västerås · www.exin.se</p>' +
      '</div>'
    );
  }

  function stripPostedParam() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('contact_posted')) return;
      url.searchParams.delete('contact_posted');
      var clean = url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '');
      window.history.replaceState(window.history.state, '', clean);
    } catch (e) {}
  }

  // Öppnad via "Öppna som PDF"-länken i mejlet (se inline-skriptet i drawer-snippeten)
  function checkPdfLink() {
    var data = window.__exqLinkData;
    if (!data) return false;
    window.__exqLinkData = null;
    var p;
    try { p = unpackReceipt(data); } catch (e) { return false; }
    lastReceipt = p;
    showPdfViewer(p).catch(function () {
      receiptEl.innerHTML = receiptHTML(p);
      open('done');
    });
    return true;
  }

  function checkReturnFromSubmit() {
    var pending = readJSON(PENDING_KEY);
    if (!pending || !pending.ts || Date.now() - pending.ts > PENDING_MAX_AGE) {
      if (pending) writeJSON(PENDING_KEY, null);
      return;
    }
    var stateEl = $('[data-exq-form-state]');
    var posted = /[?&]contact_posted=true/.test(window.location.search) ||
      (stateEl && stateEl.getAttribute('data-posted') === 'true');
    var errors = stateEl && stateEl.getAttribute('data-errors') === 'true';

    if (posted && !errors) {
      writeJSON(PENDING_KEY, null);
      writeJSON(ITEMS_KEY, null);
      renderTab([]);
      lastReceipt = pending;
      receiptEl.innerHTML = receiptHTML(pending);
      open('done');
      stripPostedParam();
    } else if (errors) {
      // Något gick fel hos Shopify — återställ uppgifterna och låt kunden försöka igen
      var c = pending.contact || {};
      form.querySelector('[name="contact[Namn]"]').value = c.name || '';
      form.querySelector('[name="contact[Företag]"]').value = c.company || '';
      form.querySelector('[name="contact[email]"]').value = c.email || '';
      form.querySelector('[name="contact[Telefon]"]').value = c.phone || '';
      $('[data-exq-wishes]').value = pending.wishes || '';
      writeJSON(PENDING_KEY, null);
      open('contact');
      errorEl.textContent = 'Förfrågan kunde inte skickas. Kontrollera uppgifterna och försök igen, eller ring oss på 021-17 17 30.';
      errorEl.hidden = false;
    }
  }

  function printReceipt() {
    document.documentElement.classList.add('exq-printing');
    var done = function () {
      document.documentElement.classList.remove('exq-printing');
      window.removeEventListener('afterprint', done);
    };
    window.addEventListener('afterprint', done);
    window.print();
    setTimeout(done, 1500);
  }

  /* ---------- PDF-nedladdning ----------
     Egen kopia av jsPDF + Funnel Sans (assets/exin-quote-jspdf*.js — identiska med
     Workspace Studios ews-jspdf*.js men fristående, så studio-städning inte slår
     ut offert-PDF:en). Laddas först vid klick. */
  var jsPdfPromise = null;
  function loadScript(url) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('Kunde inte ladda ' + url)); };
      document.head.appendChild(s);
    });
  }
  function loadJsPdf() {
    if (jsPdfPromise) return jsPdfPromise;
    var fontsLoaded = function () {
      // Studions eller vår egen typsnittsfil — båda registrerar samma Funnel Sans
      return !!document.querySelector('script[src*="ews-jspdf-fonts"], script[src*="exin-quote-jspdf-fonts"]');
    };
    jsPdfPromise = (window.jspdf && window.jspdf.jsPDF ? Promise.resolve() : loadScript(root.getAttribute('data-jspdf')))
      .then(function () {
        if (!window.jspdf || !window.jspdf.jsPDF) throw new Error('jsPDF saknas');
        return fontsLoaded() ? null : loadScript(root.getAttribute('data-jspdf-fonts'));
      })
      .then(function () { return window.jspdf.jsPDF; });
    jsPdfPromise.catch(function () { jsPdfPromise = null; });
    return jsPdfPromise;
  }

  // Bild → JPEG-dataURL via canvas (vit bakgrund, fungerar oavsett originalformat)
  function imageData(src, maxPx) {
    return new Promise(function (resolve) {
      if (!src) return resolve(null);
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var scale = Math.min(1, maxPx / Math.max(img.naturalWidth, img.naturalHeight));
          var w = Math.max(1, Math.round(img.naturalWidth * scale));
          var h = Math.max(1, Math.round(img.naturalHeight * scale));
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d');
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, w, h);
          ctx.drawImage(img, 0, 0, w, h);
          resolve({ data: c.toDataURL('image/jpeg', 0.9), w: w, h: h });
        } catch (e) { resolve(null); }
      };
      img.onerror = function () { resolve(null); };
      img.src = src.indexOf('//') === 0 ? window.location.protocol + src : src;
    });
  }

  // Tusentalsavgränsare från toLocaleString är smala mellanslag som typsnittet saknar
  function pdfText(s) { return String(s == null ? '' : s).replace(/[  ]/g, ' '); }

  function pdfName(p) { return 'Offertforfragan-' + (p.ref || 'EXIN') + '.pdf'; }

  function downloadPdf(btn) {
    var p = lastReceipt;
    if (!p) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Skapar PDF…';
    var reset = function () { btn.disabled = false; btn.textContent = label; };
    buildPdf(p).then(function (doc) {
      doc.save(pdfName(p));
      reset();
    }).catch(function () {
      reset();
      printReceipt(); // reserv: webbläsarens utskrift/spara som PDF
    });
  }

  // Bygger PDF-dokumentet (jsPDF) för en förfrågan
  function buildPdf(p) {
    return Promise.all([
      loadJsPdf(),
      imageData(root.getAttribute('data-logo'), 600),
      Promise.all((p.items || []).map(function (it) { return imageData(it.image, 240); }))
    ]).then(function (res) {
      var JsPDF = res[0], logo = res[1], imgs = res[2];
      var doc = new JsPDF({ unit: 'mm', format: 'a4' });
      var font = doc.getFontList && doc.getFontList().FunnelSans ? 'FunnelSans' : 'helvetica';
      var W = 210, M = 18, R = W - M, y = 18;
      var red = [196, 48, 28], ink = [17, 17, 17], muted = [110, 110, 110], line = [225, 218, 208];
      var c = p.contact || {};
      var setF = function (style, size, color) {
        doc.setFont(font, style); doc.setFontSize(size); doc.setTextColor.apply(doc, color || ink);
      };
      var footer = function () {
        doc.setDrawColor.apply(doc, line); doc.setLineWidth(0.3); doc.line(M, 280, R, 280);
        setF('normal', 7.5, muted);
        doc.text('Exin Bygg & Inredning i Västerås AB · Metallverksgatan 21, 721 30 Västerås · 021-17 17 30 · info@exin.se · www.exin.se', W / 2, 285, { align: 'center' });
        doc.text('Priserna är ordinarie webbshoppriser exkl. moms och utgör ingen offert.', W / 2, 289, { align: 'center' });
      };
      var ensure = function (h) {
        if (y + h > 272) { footer(); doc.addPage(); y = 20; }
      };

      // Sidhuvud
      var headH = 20;
      if (logo) {
        var lw = 40, lh = lw * logo.h / logo.w;
        if (lh > 24) { lh = 24; lw = lh * logo.w / logo.h; }
        doc.addImage(logo.data, 'JPEG', M, y, lw, lh);
        headH = Math.max(headH, lh);
      }
      setF('bold', 20); doc.text('Offertförfrågan', R, y + 7, { align: 'right' });
      setF('normal', 10, muted);
      doc.text('Referens: ' + pdfText(p.ref), R, y + 14, { align: 'right' });
      doc.text('Datum: ' + pdfText(p.date), R, y + 19, { align: 'right' });
      y += headH + 8;

      // Kontaktuppgifter
      doc.setFillColor(252, 247, 241);
      doc.roundedRect(M, y, R - M, 26, 3, 3, 'F');
      var col = function (x, yy, lbl, val) {
        setF('normal', 7.5, muted); doc.text(lbl.toUpperCase(), x, yy);
        setF('bold', 10); doc.text(pdfText(val || '–'), x, yy + 5);
      };
      col(M + 6, y + 8, 'Namn', c.name);
      col(M + 6, y + 19, 'E-post', c.email);
      col(M + 92, y + 8, 'Företag', c.company);
      col(M + 92, y + 19, 'Telefon', c.phone);
      y += 36;

      // Tabellhuvud
      var xQty = 132, xPrice = 158, xSum = R;
      setF('bold', 8.5, muted);
      doc.text('PRODUKT', M, y);
      doc.text('ANTAL', xQty, y, { align: 'right' });
      doc.text('PRIS/ST', xPrice, y, { align: 'right' });
      doc.text('SUMMA', xSum, y, { align: 'right' });
      y += 3;
      doc.setDrawColor.apply(doc, line); doc.setLineWidth(0.3); doc.line(M, y, R, y);
      y += 5;

      // Rader
      (p.items || []).forEach(function (it, i) {
        var img = imgs[i];
        var tx = M + 22, tw = xQty - 14 - tx;
        setF('bold', 10.5);
        var titleLines = doc.splitTextToSize(pdfText(it.title), tw);
        var sub = [];
        var vl = variantLabel(it);
        if (vl) sub.push(vl);
        if (it.sku) sub.push('Art.nr ' + it.sku);
        setF('normal', 9, muted);
        var subLines = sub.length ? doc.splitTextToSize(pdfText(sub.join(' · ')), tw) : [];
        var noteLines = it.note ? doc.splitTextToSize(pdfText('Kommentar: ' + it.note), tw) : [];
        var textH = titleLines.length * 4.6 + subLines.length * 4.2 + noteLines.length * 4.2;
        var rowH = Math.max(18, textH + 2);
        ensure(rowH + 4);

        if (img) {
          var s = 18, iw = img.w >= img.h ? s : s * img.w / img.h, ih = img.h >= img.w ? s : s * img.h / img.w;
          doc.addImage(img.data, 'JPEG', M + (s - iw) / 2, y + (s - ih) / 2, iw, ih);
        }
        var ty = y + 4.5;
        setF('bold', 10.5); doc.text(titleLines, tx, ty);
        if (it.url) doc.link(M, y, xQty - 14 - M, Math.max(18, titleLines.length * 4.6 + 1), { url: itemUrl(it) }); // bild + namn klickbara
        ty += titleLines.length * 4.6;
        if (subLines.length) { setF('normal', 9, muted); doc.text(subLines, tx, ty); ty += subLines.length * 4.2; }
        if (noteLines.length) { doc.setFont(font, 'normal'); doc.setTextColor.apply(doc, ink); doc.text(noteLines, tx, ty); }

        setF('normal', 10);
        doc.text((it.qty || 1) + ' st', xQty, y + 4.5, { align: 'right' });
        doc.text(pdfText(money(it.price, true)), xPrice, y + 4.5, { align: 'right' });
        setF('bold', 10);
        doc.text(pdfText(money((it.price || 0) * (it.qty || 1), true)), xSum, y + 4.5, { align: 'right' });

        y += rowH + 2;
        doc.setDrawColor.apply(doc, line); doc.line(M, y, R, y);
        y += 4;
      });

      // Totalt
      ensure(14);
      setF('bold', 12);
      doc.text('Totalt', M, y + 4);
      doc.setTextColor.apply(doc, red);
      doc.text(pdfText(money(totalCents(p.items || []), true)), xSum, y + 4, { align: 'right' });
      setF('normal', 8.5, muted);
      doc.text('exkl. moms', xSum, y + 9, { align: 'right' });
      y += 18;

      // Önskemål
      if (p.wishes) {
        setF('normal', 10);
        var wl = doc.splitTextToSize(pdfText(p.wishes), R - M);
        ensure(8 + wl.length * 4.6);
        setF('bold', 10.5); doc.text('Önskemål', M, y); y += 5.5;
        setF('normal', 10); doc.text(wl, M, y); y += wl.length * 4.6 + 4;
      }

      footer();
      doc.setProperties({ title: 'Offertförfrågan ' + (p.ref || '') });
      return doc;
    });
  }

  /* Öppnad via mejllänken: visa bara PDF:en i helskärm (webbläsarens PDF-visare)
     med en smal list för nedladdning. Mobil/fel → vanliga tackrutan som reserv. */
  function showPdfViewer(p) {
    var small = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (small) return Promise.reject(new Error('mobil'));
    var viewer = document.createElement('div');
    viewer.className = 'exq-pdfview';
    viewer.innerHTML =
      '<div class="exq-pdfview__bar">' +
        '<strong>Offertförfrågan ' + esc(p.ref) + '</strong>' +
        '<span class="exq-pdfview__who">' + esc((p.contact && (p.contact.company || p.contact.name)) || '') + '</span>' +
        '<span class="exq-pdfview__spacer"></span>' +
        '<button type="button" class="exq-btn exq-btn--primary" data-exq-pv-download>Ladda ner PDF</button>' +
        '<button type="button" class="exq-btn exq-btn--ghost" data-exq-pv-close>Stäng</button>' +
      '</div>' +
      '<div class="exq-pdfview__loading no-empty">Skapar PDF…</div>';
    document.body.appendChild(viewer);
    document.documentElement.classList.add('exq-lock');

    return buildPdf(p).then(function (doc) {
      var url = URL.createObjectURL(doc.output('blob'));
      var frame = document.createElement('iframe');
      frame.className = 'exq-pdfview__frame';
      frame.title = 'Offertförfrågan ' + (p.ref || '');
      frame.src = url;
      viewer.querySelector('.exq-pdfview__loading').replaceWith(frame);
      viewer.querySelector('[data-exq-pv-download]').addEventListener('click', function () { doc.save(pdfName(p)); });
      viewer.querySelector('[data-exq-pv-close]').addEventListener('click', function () {
        viewer.remove();
        document.documentElement.classList.remove('exq-lock');
        URL.revokeObjectURL(url);
      });
    }).catch(function (err) {
      viewer.remove();
      document.documentElement.classList.remove('exq-lock');
      throw err;
    });
  }

  /* ---------- händelser ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var addBtn = t.closest && t.closest('[data-exq-add]');
    if (addBtn) { e.preventDefault(); addFromButton(addBtn); return; }
    if (!root.contains(t)) return;

    if (t.closest('[data-exq-open]') || t.closest('[data-exq-open-toast]')) {
      toastEl.classList.remove('is-visible'); toastEl.hidden = true;
      open('list'); return;
    }
    if (t.closest('[data-exq-close]')) { close(); return; }
    if (t === overlay) { close(); return; }
    if (t.closest('[data-exq-next]')) {
      if (!getItems().length) return;
      open('contact');
      var first = form.querySelector('[name="contact[Namn]"]');
      if (first && !first.value) setTimeout(function () { first.focus(); }, 50);
      return;
    }
    if (t.closest('[data-exq-back]')) { open('list'); return; }
    if (t.closest('[data-exq-print]')) { printReceipt(); return; }
    var pdfBtn = t.closest('[data-exq-pdf]');
    if (pdfBtn) { if (!pdfBtn.disabled) downloadPdf(pdfBtn); return; }

    var row = t.closest('.exq-row');
    if (row) {
      var i = parseInt(row.getAttribute('data-index'), 10);
      var items = getItems();
      if (!items[i]) return;
      if (t.closest('[data-exq-remove]')) {
        items.splice(i, 1); setItems(items); return;
      }
      var step = t.closest('[data-exq-qty]');
      if (step) {
        items[i].qty = Math.max(1, Math.min(9999, (items[i].qty || 1) + parseInt(step.getAttribute('data-exq-qty'), 10)));
        setItems(items);
      }
    }
  });

  root.addEventListener('change', function (e) {
    var row = e.target.closest && e.target.closest('.exq-row');
    if (!row) return;
    var i = parseInt(row.getAttribute('data-index'), 10);
    var items = getItems();
    if (!items[i]) return;
    if (e.target.matches('[data-exq-qty-input]')) {
      var q = parseInt(e.target.value, 10);
      items[i].qty = q > 0 ? Math.min(q, 9999) : 1;
      setItems(items);
    }
  });

  // Kommentarer sparas medan man skriver, utan att rita om listan (behåller fokus)
  root.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-exq-note]')) return;
    var row = e.target.closest('.exq-row');
    var i = parseInt(row.getAttribute('data-index'), 10);
    var items = getItems();
    if (!items[i]) return;
    items[i].note = e.target.value.slice(0, 300);
    writeJSON(ITEMS_KEY, items);
  });

  form.noValidate = true; // egen validering med tydligt felmeddelande (se validate())
  form.addEventListener('submit', submit);

  document.addEventListener('keydown', function (e) {
    if (overlay.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), textarea:not([hidden]), [tabindex]:not([tabindex="-1"])', modal)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Synka mellan flikar + moms-växeln
  window.addEventListener('storage', function (e) { if (e.key === ITEMS_KEY) renderAll(); });
  document.addEventListener('exin:vat-changed', renderAll);

  renderTab(getItems());
  if (!checkPdfLink()) checkReturnFromSubmit();
})();
